import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ChartContainer } from '../../../../../common/chart/chartContainer'
import Bar from '../../../../../common/chart/chartContainer/Bar'
import Line from '../../../../../common/chart/chartContainer/Line'
import { LegendItem } from '../../../../../common/chart/legend/LegendItem'
import { Element } from '../../../../../common/html/element'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { getUnique } from '../../../../../helpers/common'
import { selectUserType } from '../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../utils/authorization'
import {
  getNoDataComponent,
  getStyleHeightContainer,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../helper'
import classes from '../../index.module.scss'
import { changeChecked, selectChecked } from '../../store/slice'
import { convertData, valToPercent } from './../../../../../helpers/value'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

const Trend = ({ id, isDynamicReport, check, isDownloadComponent }) => {
  const dispatch = useDispatch()

  const {
    decimalLength,
    getExchangeRate,
    multiplier,
    formatedUnit,
    formatValueWithUnit,
  } = useFormatCurrency(SCREEN.FINANCIAL_ANALYSIS)
  const locale = useSelector((state) => state.i18n.locale)
  const data = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))
  const userType = useSelector(selectUserType)

  const chartId = useRef(getUnique())

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const checkboxs = [
    {
      ...getValueAndTitleCheckbox(indicatorById, 'IS51'),
      color: '#006AA6',
      isBarChart: true,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'IS91'),
      color: '#FFCD60',
      isBarChart: true,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'IS94'),
      color: '#F49966',
      isBarChart: true,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'IS16'),
      color: '#C3D785',
      isBarChart: true,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'RT0050'),
      color: '#FF596A',
      isLineChart: true,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'RT0416'),
      color: '#7F63B9',
      isLineChart: true,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'RT2002'),
      color: '#00A8B5',
      isLineChart: true,
    },
  ]

  const bars = checkboxs.filter(
    (item) => item.isBarChart && checked.includes(item.value),
  )

  const lines = checkboxs.filter(
    (item) => item.isLineChart && checked.includes(item.value),
  )

  const dataConvert = convertData(
    data,
    getExchangeRate,
    indicatorById,
    multiplier,
    ['year'],
    lines.map((item) => item.value),
  )

  const isNoData = !dataConvert.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  return (
    <div
      style={{
        height: getStyleHeightContainer(
          isDynamicReport || isDownloadComponent,
          isNoData,
          332,
        ),
      }}
    >
      {isNoData ? (
        getNoDataComponent(isDynamicReport)
      ) : (
        <div className={`dFlex h100 ${classes.profitabilityTrenContainer}`}>
          <div className="flexColumn h100 w70">
            <Element className={classes.pdb6} style={{ color: '#9C9C9C' }}>
              {bars.length ? formatedUnit : <>&nbsp;</>}
            </Element>
            <ChartContainer
              chartId={chartId.current}
              data={dataConvert}
              margin={{
                top: 15,
                bottom: 0,
                left: isDynamicReport || isDownloadComponent ? 16 : 0,
                right: isDynamicReport || isDownloadComponent ? 16 : 0,
              }}
              width="100%"
              height={260}
              xAxis={[
                {
                  dataKey: 'year',
                  tickMargin: 10,
                  height: 30,
                },
              ]}
              yAxis={[
                {
                  yAxisId: 'left',
                  dataKeys: bars.map((item) => item.value),
                  isBarChart: true,
                  decimalLength,
                },
                {
                  yAxisId: 'right',
                  orientation: 'right',
                  dataKeys: lines.map((item) => item.value),
                  isLineChart: true,
                  unit: '%',
                },
              ]}
              tooltip={{
                schema: {
                  content: [
                    ...bars.map((bar) => ({
                      dataKey: bar.value,
                      label: bar.title,
                      formatValue: (value) => formatValueWithUnit({ value }),
                    })),
                    ...lines.map((line) => ({
                      dataKey: line.value,
                      label: line.title,
                      formatValue: (val) => valToPercent(val, locale, true),
                    })),
                  ],
                },
              }}
            >
              {bars.map((bar) => (
                <Bar
                  key={bar.value}
                  yAxisId="left"
                  dataKey={bar.value}
                  fill={bar.color}
                  maxBarSize={35}
                />
              ))}
              {lines.map((line) => (
                <Line
                  key={line.value}
                  yAxisId="right"
                  dataKey={line.value}
                  stroke={line.color}
                />
              ))}
            </ChartContainer>
          </div>
          <div className="h100 w30 px1 py1 dFlex alignItemsCenter justifyContentCenter">
            <ScrollComponent>
              <span>
                {checkboxs.map((item, index) => (
                  <div
                    key={item.value}
                    style={{ marginTop: index !== 0 ? 12 : 0 }}
                  >
                    <LegendItem
                      title={item.title}
                      value={item.value}
                      color={item.color}
                      isCheckbox={userType?.userTypeId === USER_TYPE.PREMIUM}
                      dataKey={item.value}
                      chartId={chartId.current}
                      listCheckBox={checked}
                      setListCheckBox={setChecked}
                      isI18n={false}
                      isDynamicReport={isDynamicReport || isDownloadComponent}
                    />
                  </div>
                ))}
              </span>
            </ScrollComponent>
          </div>
        </div>
      )}
    </div>
  )
}

Trend.propTypes = {
  id: PropTypes.string,
}

export default Trend
